(ns portal.v2-user-table.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium]]
            [clojure.string :as str]
            [common.queries :refer [use-query]]
            [common.widgets.data-grid :as dg]
            [portal.v2-user-table.ocp]
            [portal.v2-user-table.queries :as q]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn- format-grants [grants]
  (->> grants
       (map (fn [grant]
              (let [role-name (:role-name grant)
                    scope-type (:scope-type grant)
                    scope-name (case scope-type
                                 "agency" (get-in grant [:scope :agency :name])
                                 "advertiser" (get-in grant [:scope :advertiser :name])
                                 nil)]
                (if scope-name
                  (str role-name " (" scope-name ")")
                  role-name))))
       (distinct)
       (sort)
       (str/join ", ")))

(def columns
  #js [#js {:field "name"
            :headerName "Name"
            :sortable true
            :filterable true
            :flex 1
            :valueGetter (fn [_value row]
                           (:name row))}
       #js {:field "email"
            :headerName "Email"
            :sortable true
            :filterable true
            :flex 1
            :valueGetter (fn [_value row]
                           (:email row))}
       #js {:field "roles"
            :headerName "Roles"
            :sortable false
            :filterable true
            :flex 2
            :valueGetter (fn [_value row]
                           (format-grants (:grants row)))}])

(def Toolbar
  (uix/as-react
   (fn [{:keys [create-allowed?]}]
     ($ dg/grid-toolbar
        (when create-allowed?
          ($ Button
             {:on-click #(rf/dispatch [:ocp/open {:id :v2-user/create}])
              :variant "contained"
              :data-testid "add-v2-user-button"}
             "Add User"))))))

(defui v2-user-data-grid []
  (let [{:keys [isPending] data :data} (use-query (q/v2-users-query))
        items (:items data)
        create-allowed? (use-subscribe [:resource.user/allowed? "useraccounts.create"])
        page-size 10

        get-row-id (uix/use-callback (fn [row]
                                       (:id row))
                                     [])

        on-row-click (uix/use-callback (fn [^js params]
                                         (let [user (.-row params)]
                                           (rf/dispatch [:ocp/open {:id :v2-user/crud
                                                                    :props {:user user}}])))
                                       [])]
    ($ DataGridPremium
       {:columns columns

        :loading isPending

        :rows (to-array items)
        :getRowId get-row-id
        :onRowClick on-row-click

        :checkboxSelection false
        :disableRowSelectionOnClick false

        :pagination true
        :pageSizeOptions #js [page-size]

        :localeText #js {:noRowsLabel "No users found"}
        :initialState #js {:pagination #js {:paginationModel #js {:pageSize page-size}}}

        :slots #js {:toolbar Toolbar}
        :slotProps #js {:baseTextField dg/grid-toolbar-outlined-input
                        :toolbar #js {:create-allowed? create-allowed?}}

        :sx #js {:maxHeight "70rem"
                 "& .MuiDataGrid-row:hover" #js {:cursor "pointer"}}})))
